// extracted by mini-css-extract-plugin
export var standaloneTable = "_22-0";
export var standaloneTableWithBodyFill = "_22-1";
export var withExtraHeader = "_22-2";